import { useTranslation } from 'react-i18next';
import type { SupportTicketEvent } from '@/api/support/supportApi.types';
import { Icon, type IconName } from '@/components/common/Icon';
import { formatIsoDateTimeToTimestamp } from '@/utils/dateFormatting';
import { buildEventTranslationKey } from './supportLabels';

const EVENT_ICONS: Record<string, IconName> = {
  created: 'Plus',
  assigned: 'UserPlus',
  reassigned: 'UserPlus',
  status_changed: 'RefreshCw',
  priority_changed: 'Tag',
  reopened: 'Undo',
  resolved: 'CheckCircle',
  closed: 'Check',
};

function resolveEventIcon(eventType: string): IconName {
  const icon = EVENT_ICONS[eventType];
  return icon === undefined ? 'Clock' : icon;
}

export function TicketTimeline({ events }: { events: SupportTicketEvent[] }) {
  const { t } = useTranslation('support');
  if (events.length === 0) {
    return null;
  }
  return (
    <div className="space-y-3">
      {events.map(function renderEvent(event) {
        return (
          <div key={event.id} className="flex items-start gap-3">
            <span className="mt-0.5 w-7 h-7 rounded-full bg-zoovpalelavender text-zooviolet flex items-center justify-center shrink-0">
              <Icon name={resolveEventIcon(event.eventType)} />
            </span>
            <div className="min-w-0 flex-1">
              <div className="text-[13px] text-zooindigo">
                <span className="font-semibold">{t(buildEventTranslationKey(event.eventType))}</span>
                {event.actorName === null ? null : (
                  <span className="text-zoomuted"> · {event.actorName}</span>
                )}
              </div>
              {event.detail === null || event.detail.length === 0 ? null : (
                <div className="text-[12px] text-zoomuted truncate">{event.detail}</div>
              )}
              <div className="text-[11px] text-zoomuted">
                {formatIsoDateTimeToTimestamp(event.createdAt)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
